























































import { Prop, Component, Vue } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import StaffApi from "@/api/staff-api";
import { client } from "@/api/request";
import Staff from "@/entities/staff";
import { GetSalesReportQuery } from "@/sales/api/sales-report-api";
import SelectCompanyType from "@/components/SelectCompanyType.vue";
import SelectCompany from "@/components/SelectCompany.vue";
import { GetSalesReportQueryDetails } from "./SalesReportQuery.vue";

@Component({
  components: {
    SelectCompanyType,
    SelectCompany
  }
})
export default class SearchSalesReportBar extends Vue {
  @Prop({ required: true }) query!: GetSalesReportQuery;
  @Prop() projectId!: string;
  @Prop({
    type: Object,
    default: () => ({
      companyName: "",
      companyTypeName: "",
      staffName: "",
      vendorName: "",
      periodName: ""
    })
  })
  queryDetails!: GetSalesReportQueryDetails;

  monthOptions: SelectOption[] = [
    { text: "期間", value: "" },
    { text: "1ヶ月間", value: "1" },
    { text: "2ヶ月間", value: "2" },
    { text: "3ヶ月間", value: "3" },
    { text: "4ヶ月間", value: "4" },
    { text: "5ヶ月間", value: "5" },
    { text: "6ヶ月間", value: "6" },
    { text: "7ヶ月間", value: "7" },
    { text: "8ヶ月間", value: "8" },
    { text: "9ヶ月間", value: "9" },
    { text: "10ヶ月間", value: "10" },
    { text: "11ヶ月間", value: "11" },
    { text: "12ヶ月間", value: "12" },
    { text: "年間", value: "13" }
  ];

  staff: Staff[] = [];

  get staffOptions(): SelectOption[] {
    return [
      {
        text: "全ての発注担当者",
        value: ""
      }
    ].concat(
      this.staff.map(s => ({
        text: s.name,
        value: String(s.id)
      }))
    );
  }

  public created() {
    this.initStaffList();
  }

  getSelectedStaffText(): string {
    const option = this.staffOptions.find(o => o.value === this.query.staffId);
    return option ? option.text : "";
  }

  getSelectedPeriodText(): string {
    const option = this.monthOptions.find(
      o => o.value === this.query.monthOptions
    );
    return option ? option.text : "";
  }

  submit() {
    this.queryDetails.staffName = this.getSelectedStaffText();
    this.queryDetails.periodName = this.getSelectedPeriodText();
    this.$emit("submit", this.query);
  }

  private async initStaffList(options?: { family: string }) {
    this.staff = await new StaffApi(client).getAll(options);
  }
}
